import React, {useEffect, useState} from "react";
import {Button, Radio, Text} from "../../components/inputs/ajonjolinput";
import Sidebar from "../../components/sidebar/sidebar";
import styles from './home.module.css';
import {handleConnect, handleSendMessage, setupPrints} from "../../utils/serial";
import ToastContainer from "../../components/toasts/toast/toast_container";

function Title({children}) {
    return (
        <div className={styles.inputTitle}>
            {children}
        </div>
    )
}

function Section({description, children}) {
    return (
        <div className={styles.section}>
            <div className={styles.description} style={{
                marginTop: '1rem'
            }}>{description}</div>
            <div className={styles.optionsContainer}>
                {children}
            </div>
        </div>
    )
}

export default function HomeScreen() {
    const [form, setForm] = useState({
        antennas: '1 Antenna',
        offset_1: 0,
        height_1: 0,
        offset_2: 0,
        height_2: 0,
        mode: "0,"
    });

    const [distance, setDistance] = useState(0.0);

    useEffect(() => {
        //setupPrints();
    }, []);

    return (
        <div style={{height: '100vh'}}>
            <Sidebar/>
            <div className={styles.container}>
                <div style={{display: 'flex', flexDirection: 'column', width: '90%', marginTop: '3rem'}}>
                    <div className={styles.title}>Configuration</div>
                    <Section description={'Device parameters'}>
                        <div style={{display: 'flex'}}>
                            <Button name={'Select Device'} variant={'primary'} onSubmit={() => handleConnect(form["antennas"], form["mode"], setForm, setDistance)}/>
                        </div>
                        <div style={{marginBottom: '1rem'}}/>
                        <Radio.Group value={form['antennas']} onChange={(value) => {
                            setForm({
                                ...form,
                                "antennas": value
                            });
                        }}>
                            <Radio.Input value={'1 Antenna'}/>
                            <Radio.Input value={'2 Antenna'}/>
                        </Radio.Group>
                    </Section>

                    <Section description={'Antenna 1 parameters'}>
                        <Title>Offset</Title>
                        <Text placeholder={'Offset'} value={form['offset_1']} onChange={(value) => {
                            setForm({
                                ...form,
                                "offset_1": value
                            })
                        }}/>
                        <div style={{marginBottom: '1rem'}}/>

                        <Title>Alert Distance</Title>
                        <Text placeholder={'Alert Distance'} value={form['height_1']} onChange={(value) => {
                            setForm({
                                ...form,
                                "height_1": value
                            })
                        }}/>
                    </Section>

                    {form['antennas'] === '2 Antenna' && <Section description={'Antenna 2 parameters'}>
                        <Title>Offset</Title>
                        <Text placeholder={'Offset'} value={form['offset_2']} onChange={(value) => {
                            setForm({
                                ...form,
                                "offset_2": value
                            })
                        }}/>
                        <div style={{marginBottom: '1rem'}}/>

                        <Title>Alert Distance</Title>
                        <Text placeholder={'Alert Distance'} value={form['height_2']} onChange={(value) => {
                            setForm({
                                ...form,
                                "height_2": value
                            })
                        }}/>
                    </Section>}

                    <Section description={''}>
                        <div style={{
                            display: 'flex',
                            marginLeft: 'auto'
                        }}>
                            <Button variant={'success'} name={'Update'} onSubmit={() => handleSendMessage(form)}/>
                        </div>
                    </Section>
                </div>
            </div>
            <div className={styles.distanceContainer}>
                <div className={styles.distanceBox}>{distance > 0 ? distance.toFixed(2) : 0}m</div>
            </div>
            <ToastContainer/>
        </div>
    )
}